// extracted by mini-css-extract-plugin
export var styles = "footer-module--styles--3kiZ6";
export var zzz = "footer-module--zzz--2-tMl";
export var footer = "footer-module--footer--1j3nN";